import { render, staticRenderFns } from "./ChooseUserModal.vue?vue&type=template&id=56f6005e&scoped=true&"
import script from "./ChooseUserModal.vue?vue&type=script&lang=js&"
export * from "./ChooseUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseUserModal.vue?vue&type=style&index=0&id=56f6005e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6005e",
  null
  
)

export default component.exports